import { combineReducers } from 'redux';

import { reducer as details } from './detailsModule';
import { reducer as updateOrCreate } from './updateOrCreateModule';

export default combineReducers({
	details,
	updateOrCreate,
});
